import React, { useEffect, useState } from "react";
import { FaSearch, FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { Form } from "react-bootstrap";
import { getUserByKeyword, getErrorByField } from "../../Api/auth";
import { getStaffByKeyword, getStafflistapi } from "../../Api/staff";
import { Roller } from "react-awesome-spinners";
import { getGrassyByKeyword } from "../../Api/grassy";

function Events() {
    const [isLoading, setIsLoading] = useState(true);
    const [validated, setValidated] = React.useState(false);
    const [apicall, setApicall] = React.useState(false);
    const [errors, setErrors] = React.useState([]);

    const [keyword, setKeyword] = React.useState("");
    const [staffList, setStaffList] = React.useState([]);
    const [respCode, setResCode] = React.useState(0);

    const handleSearchChange = (e) => {
        setKeyword(e.target.value);
    }
    const handlegetCustomer = (event) => {
        setApicall(true);
        setIsLoading(true);
        event.preventDefault();
        const data = { params: { keyword } }
        getGrassyByKeyword(data, event).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                setStaffList(res.data.data);
            }
            setResCode(res.data.status);
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setIsLoading(false);
        });
        setValidated(true);
    }


    const getStafflist = () => {
        setApicall(true);
        setIsLoading(true);
        const data = { params: { keyword } }
        getGrassyByKeyword(data).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                setStaffList(res.data.data);
            }
            setResCode(res.data.status);
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setIsLoading(false);
        });
        setValidated(true);
    }

    useEffect(() => {
        getStafflist();
    }, []);





    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Roller />
                    </div>
                ) : (
                    <>
                        <div>
                            <div className="main-page-body-content-header">
                                <HeaderAdmin />
                            </div>
                            <div className="dashboard-container d-flex">
                                <div className="main-container">
                                    <div className="main-page-body-content">
                                        <div className="main-page-body-content-body">
                                            <div className="main-page-body-content-body-container">
                                                <div className="container-fluid">
                                                    <div className="sec-header-dash">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3>User List</h3>
                                                        </div>
                                                        <div className="content-box-btn">
                                                            {/* <Link to="/grassy" >
                                                                <button className="btn btn-add">Add</button>
                                                            </Link> */}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="p-1 rounded shadow-sm mb-4 mt-4" style={{ background: '#fff' }}>
                                                            <Form noValidate validated={validated} onSubmit={handlegetCustomer}>
                                                                <div className="input-group">
                                                                    <input
                                                                        required
                                                                        placeholder="What're you searching for?"
                                                                        aria-describedby="button-addon1"
                                                                        value={keyword}
                                                                        onChange={handleSearchChange}
                                                                        className={`form-control dash-search-box border-0 ${errors.length > 0 ? getErrorByField(errors, "email").length > 0 ? "is-invalid" : "" : ""}`}
                                                                    />
                                                                    <div className="input-group-append">
                                                                        <button id="button-addon1" type="submit" className="btn btn-link searchbaar-btn" >
                                                                            <FaSearch />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </Form>
                                                        </div>
                                                        {
                                                            staffList.length === 0 && respCode !== 0 ? (
                                                                <div className="no-data-found">
                                                                    <div className='no-data-img'>
                                                                        <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                    </div>
                                                                    <div className="no-data-text">
                                                                        <h3>No Event Found</h3>
                                                                    </div>
                                                                    <div className='no-data-btn'>
                                                                        <Link to="/grassy">
                                                                            <button className="btn btn-add">Add Event</button>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                staffList.map((user, index) => (
                                                                    <div className="form-box-section mt-3" key={index}>
                                                                        <div className="profile">
                                                                            <div className="profile-details">
                                                                                <div className="user-name">
                                                                                    <h3>{`${user.firstname} ${user.lastname}`}</h3>
                                                                                </div>
                                                                                <div className="user-email">
                                                                                    {user.email}
                                                                                </div>
                                                                            </div>
                                                                            <div className="content-box-btn">
                                                                                <Link to={`/Grassy-views/${user._id}`}>
                                                                                    <button className="btn btn-edit"><FaEye /></button>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    </>
                )
            }
        </>
    );
}

export default Events;